// frontend/admin-portal/src/components/procurement/PurchaseOrderStatusBadge.jsx
import React from "react";
import { Badge } from "@fiberhome/shared-ui";

const VARIANTS = {
  draft: "default",
  sent: "primary",
  partially_received: "warning",
  received: "success",
  cancelled: "danger",
};

const LABELS = {
  draft: "Draft",
  sent: "Sent to supplier",
  partially_received: "Partially received",
  received: "Received",
  cancelled: "Cancelled",
};

export default function PurchaseOrderStatusBadge({ status }) {
  return (
    <Badge variant={VARIANTS[status] || "default"}>
      {LABELS[status] || status}
    </Badge>
  );
}
